import {
  getGiftBagTemplate,
  getGiftBagList,
  hdTaskTemplateGroup,
  sellerImage,
  publicOpen,
  getValidActivity,
} from "@/api/paradiseAndTaskCommonController.js";
import { mapState } from "vuex";
import { publicOpen1, checkOpenCrmByVenderType } from "@/api/public";
import QRCode from "qrcodejs2";
export default {
  data() {
    return {
      tempSwitchList: [
        {
          isVisible: true,
          title: "全部",
          id: "",
        },
      ],
      tempItem: {},
      tempIndex: 0,
      loading: false,
      giftList: [],
      activityData: {},
      pageData: {
        size: 10000,
        current: 1,
        total: 0,
      },
      form: {
        name: "",
        id: "",
      },
      orderCRM: false,
      orderCRMtime: "",
      activityDataInfo: {},
    };
  },
  computed: {
    ...mapState(["venderType"]),
  },
  async mounted() {
    console.log(this.$store.state.loginUserInfo.permissions, 6661);
    // console.log(this.activityData, 3333);
    let activityObj = this.handleRouteType();
    this.activityData = {
      ...activityObj,
      telImg: activityObj.src,
      name: activityObj.title,
      telCode: activityObj.codeUrl,
    };
    this.init();
  },
  methods: {
    async init() {
      if (this.fitersChooseIF([13, 14, 15])) {
        let num =
          this.activityData.id == 13 ? 0 : this.activityData.id == 14 ? 1 : 2;
        const GiftBag = await getGiftBagList(num);
        let arr = GiftBag.data;
        if (this.fitersChooseIF([13])) {
          let index = this.$store.state.loginUserInfo.permissions.indexOf(
            "open:card:upload:template"
          );
          arr[0].isVisible = index == -1 ? false : arr[0].isVisible;
          this.tempSwitchList = [
            {
              id: "",
              isVisible: true,
              title: "全部",
            },
            ...arr,
          ];
        } else {
          this.tempSwitchList = [
            {
              id: "",
              isVisible: true,
              title: "全部",
            },
            ...GiftBag.data,
          ];
        }

        this.tempItem = this.tempSwitchList[0];
        this.$nextTick(() => {
          this.getCodeIMG();
        });
        this.getPolite();
      } else if (
        this.fitersChooseIF([27, 28, 19, 1, 16, 17, 18, 8, 34, 20, 39, 41, 44, 50])
      ) {
        const { message: res1 } = await publicOpen();
        if (res1) {
          this.orderCRMtime = res1;
          this.orderCRM = false;
        } else {
          if (this.venderType) {
            this.orderCRM = true;
          } else {
            this.orderCRM = false;
          }
          this.orderCRMtime = "";
        }
        this.$nextTick(() => {
          this.getCodeIMG();
        });
        const { data } = await hdTaskTemplateGroup({
          hdTaskType: this.activityData.id,
        });
        const res = data.map((item) => {
          return {
            ...item,
            title: item.groupName,
            isVisible: item.frontHide == 0,
          };
        });
        this.tempSwitchList = [
          {
            id: "",
            title: "全部",
            frontHide: false,
            isVisible: true,
          },
          ...res,
        ];
        this.tempItem = this.tempSwitchList[0];
        this.getPolitely();
      } else if (this.fitersChooseIF([36])) {
        if (this.venderType) {
          this.orderCRM = true;
        } else {
          this.orderCRM = false;
        }
        const { data: checkData } = await checkOpenCrmByVenderType();
        console.log(checkData);
        if (checkData) {
          this.orderCRMtime = checkData;
        } else {
          this.orderCRMtime = "";
        }
        this.$nextTick(() => {
          this.getCodeIMG();
        });
        const { data } = await hdTaskTemplateGroup({
          hdTaskType: this.activityData.id,
        });
        const res = data.map((item) => {
          return {
            ...item,
            title: item.groupName,
            isVisible: item.frontHide == 0,
          };
        });
        this.tempSwitchList = [
          {
            id: "",
            title: "全部",
            frontHide: false,
            isVisible: true,
          },
          ...res,
        ];
        this.tempItem = this.tempSwitchList[0];
        this.getPolitely();
      } else if (this.fitersChooseIF([16, 17, 18])) {
        this.giftList = [
          {
            days: "",
            id: "0",
            name: this.fitersChooseIF([16])
              ? "下单有礼"
              : this.fitersChooseIF([17])
              ? "首单专享礼"
              : "复购有礼",
            imgUrl: this.fitersChooseIF([16])
              ? require("@/assets/images/integralCenter/xdyl.png")
              : this.fitersChooseIF([17])
              ? require("@/assets/images/integralCenter/sgyl.png")
              : require("@/assets/images/integralCenter/fgyl.png"),
            templateUItype: 1,
            tempCode:
              this.activityData.codeUrl + JSON.stringify({ templateUItype: 1 }),
          },
          {
            days: "",
            id: "1",
            name: this.fitersChooseIF([16])
              ? "下单有礼"
              : this.fitersChooseIF([17])
              ? "首单专享礼"
              : "复购有礼",
            imgUrl: this.fitersChooseIF([16])
              ? require("@/assets/images/integralCenter/xy_xdyz.png")
              : this.fitersChooseIF([17])
              ? require("@/assets/thdImg/actTemp/sg.png")
              : require("@/assets/thdImg/actTemp/fg.png"),
            templateUItype: 2,
            tempCode:
              this.activityData.codeUrl + JSON.stringify({ templateUItype: 2 }),
          },
        ];
        if (this.fitersChooseIF([16])) {
          let obj = {
            days: "",
            id: "2",
            name: "下单有礼",
            imgUrl: require("@/assets/thdImg/actTemp/xd.png"),
            templateUItype: 3,
            tempCode:
              this.activityData.codeUrl + JSON.stringify({ templateUItype: 3 }),
          };
          this.giftList.push(obj);
        }

        const { message: res1 } = await publicOpen();
        if (res1) {
          this.orderCRMtime = res1;
          this.orderCRM = false;
        } else {
          if (this.venderType) {
            this.orderCRM = true;
          } else {
            this.orderCRM = false;
          }
          this.orderCRMtime = "";
        }

        this.$nextTick(() => {
          this.getCodeIMG();
          this.getCodeIMG1();
        });
      } else if (this.fitersChooseIF([1])) {
        this.giftList = [
          {
            id: 1,
            imgUrl: this.activityData.telImg,
            name: this.activityData.title,
            tempCode: this.activityData.telCode1,
          },
          {
            id: 2,
            imgUrl: this.activityData.telImg2,
            name: this.activityData.title,
            tempCode: this.activityData.telCode2,
          },
          {
            id: 3,
            imgUrl: this.activityData.telImg3,
            name: this.activityData.title,
            tempCode: this.activityData.telCode3,
          },
        ];
        this.$nextTick(() => {
          this.getCodeIMG();
          this.getCodeIMG1();
        });
      } else if (this.fitersChooseIF([8])) {
        this.giftList = [
          {
            id: 1,
            imgUrl: require("@/assets/thdImg/actTemp/zp1.png"),
            name: this.activityData.title,
            tempCode:
              this.activityData.codeUrl +
              "&templateJson=" +
              JSON.stringify({ templateUItype: "1" }),
          },
          {
            id: 2,
            imgUrl: require("@/assets/thdImg/actTemp/zp2.png"),
            name: this.activityData.title,
            tempCode:
              this.activityData.codeUrl +
              "&templateJson=" +
              JSON.stringify({ templateUItype: "2" }),
          },
          {
            id: 3,
            imgUrl: require("@/assets/thdImg/actTemp/zp3.png"),
            name: this.activityData.title,
            tempCode:
              this.activityData.codeUrl +
              "&templateJson=" +
              JSON.stringify({ templateUItype: "3" }),
          },
          {
            id: 4,
            imgUrl: require("@/assets/thdImg/actTemp/zp4.png"),
            name: this.activityData.title,
            tempCode:
              this.activityData.codeUrl +
              "&templateJson=" +
              JSON.stringify({ templateUItype: "4" }),
          },
        ];
        // const { message: res1 } = await publicOpen();
        // if (res1) {
        //   this.orderCRMtime = res1;
        //   this.orderCRM = false;
        // } else {
        //   if (this.venderType) {
        //     this.orderCRM = true;
        //   } else {
        //     this.orderCRM = false;
        //   }
        //   this.orderCRMtime = "";
        // }
        this.$nextTick(() => {
          this.getCodeIMG();
          this.getCodeIMG1();
        });
      } else if (this.fitersChooseIF([19])) {
        this.giftList = [
          {
            id: 1,
            imgUrl: require("@/assets/images/integralCenter/xdcj1.png"),
            name: this.activityData.title,
            tempCode:
              this.activityData.codeUrl +
              "&templateJson=" +
              JSON.stringify({ templateUItype: "1" }),
          },
          {
            id: 2,
            imgUrl: require("@/assets/images/integralCenter/xdcj2.png"),
            name: this.activityData.title,
            tempCode:
              this.activityData.codeUrl +
              "&templateJson=" +
              JSON.stringify({ templateUItype: "2" }),
          },
          {
            id: 3,
            imgUrl: require("@/assets/thdImg/actTemp/cj.png"),
            name: this.activityData.title,
            tempCode:
              this.activityData.codeUrl +
              "&templateJson=" +
              JSON.stringify({ templateUItype: "3" }),
          },
        ];
        const { message: res1 } = await publicOpen();
        if (res1) {
          this.orderCRMtime = res1;
          this.orderCRM = false;
        } else {
          if (this.venderType) {
            this.orderCRM = true;
          } else {
            this.orderCRM = false;
          }
          this.orderCRMtime = "";
        }
        this.$nextTick(() => {
          this.getCodeIMG();
          this.getCodeIMG1();
        });
      } else {
        this.giftList.push({
          ...this.activityData,
          imgUrl: this.activityData.src,
          name: this.activityData.title,
          id: this.activityData.id,
          tempCode: this.activityData.codeUrl,
        });
        this.$nextTick(() => {
          this.getCodeIMG();
          this.getCodeIMG1();
        });
      }
    },
    handleRouteType() {
      let activityType = this.$route.meta.activityType * 1;
      let coverSrc =
        "https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=https://jdminiapp.yucrm.cn/html/images/Preview/";
      let data = {};
      let idUrl1 = `https://yq-hd-rc.isvjcloud.com/clientPreview?activityType=11&venderId=${this.$store.state.loginUserInfo.venderId}`;
      switch (activityType) {
        case 1:
          data.id = activityType;
          data.title = "签到赢好礼";
          data.content =
            "可设置连续签到的梯度签到方式奖励，通过每天签到思维模式培养，提高粉丝粘性";
          data.src = require("@/assets/thdImg/cover/qdq.png");
          data.bghome = require("@/assets/thdImg/active/qd1.png");
          data.path = idUrl1;
          data.telImg = require("../../../assets/images/integralCenter/日历签到1.png");
          data.telImg2 = require("@/assets/thdImg/actTemp/qd2.png");
          data.telImg3 = require("@/assets/thdImg/actTemp/qd3.png");
          data.telCode =
            idUrl1 + "&templateJson=" + JSON.stringify({ templateUItype: "1" });
          data.telCode1 =
            idUrl1 + "&templateJson=" + JSON.stringify({ templateUItype: "1" });
          data.telCode2 =
            idUrl1 + "&templateJson=" + JSON.stringify({ templateUItype: "2" });
          data.telCode3 =
            idUrl1 + "&templateJson=" + JSON.stringify({ templateUItype: "3" });
          data.createStep = 2;
          data.codeUrl =
            "https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=";
          data.isCover = true;
          data.coverSrc = coverSrc + "qd.png";
          data.course =
            "https://www.yuque.com/yunduanxincrm/flgan6/eccpkdye4hvu59u8";
          break;
        case 34:
          data.id = activityType;
          data.title = "加购有礼";
          data.createStep = 2;
          data.content =
            "可通过用户添加指定数目的商品至购物车，即可领取奖品，可增加商品曝光量和关注量，提高商品搜索权重";
          data.src = require("@/assets/thdImg/cover/jgyl.png");
          data.bghome = require("@/assets/thdImg/active/jgyl.png");
          data.path = idUrl1;
          data.codeUrl =
            "https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=";
          data.coverSrc = coverSrc + "jgyl.png";
          data.course =
            "https://www.yuque.com/yunduanxincrm/flgan6/rl55cm0oka4v3huy";
          break;
        case 2:
          data.id = activityType;
          data.title = "每日限时抢";
          data.content =
            "每天指定时间发放奖品，先到先得，奖品限时限量发放，营造稀缺感，培养用户习惯";
          data.src = require("@/assets/thdImg/cover/mrq.png");
          data.bghome = require("@/assets/thdImg/active/qhl.png");
          data.path = `https://yq-hd-rc.isvjcloud.com/rob_goodPresent?venderId=${this.$store.state.loginUserInfo.venderId}`;
          data.createStep = 2;
          data.codeUrl = `https://yq-hd-rc.isvjcloud.com/rob_goodPresent?venderId=${this.$store.state.loginUserInfo.venderId}`;
          data.coverSrc = coverSrc + "qhl.png";
          data.course =
            "https://www.yuque.com/yunduanxincrm/flgan6/ekrpqm53gdyn7vo6";
          break;
        case 3:
          data.id = activityType;
          data.title = "关注店铺有礼";
          data.content =
            "关注店铺嬴好礼，可增加店铺关注量，提升店铺权重，支持设置曝光商品，刺激转化提客户粘性，推广店铺必推玩法";
          data.src = require("@/assets/thdImg/cover/gzdp.png");
          data.bghome = require("@/assets/thdImg/active/gzdp.png");
          data.path = `https://yq-hd-rc.isvjcloud.com/attention_shop?venderId=${this.$store.state.loginUserInfo.venderId}`;
          data.createStep = 2;
          data.codeUrl = `https://yq-hd-rc.isvjcloud.com/attention_shop?venderId=${this.$store.state.loginUserInfo.venderId}`;
          data.isCover = true;
          data.coverSrc = coverSrc + "gz.png";
          data.course =
            "https://www.yuque.com/yunduanxincrm/flgan6/cxosummit7pce4sg";
          break;
        case 4:
          data.id = activityType;
          data.title = "邀请开卡有礼";
          data.content =
            "高效裂变玩法，引导客户邀请好友开卡，迅速增加活动曝光率，提升店铺会员量，加强品牌曝光";
          data.src = require("@/assets/thdImg/cover/kk.png");
          data.bghome = require("@/assets/thdImg/active/yqkk.png");
          data.path = `https://yq-hd-rc.isvjcloud.com/invitationopenCard?venderId=${this.$store.state.loginUserInfo.venderId}`;
          data.createStep = 5;
          data.codeUrl = coverSrc + "yqgz.png";
          data.coverSrc = coverSrc + "yqgz.png";
          data.course =
            "https://www.yuque.com/yunduanxincrm/flgan6/mqe416srqb8sod7h";
          break;
        case 5:
          data.id = activityType;
          data.title = "邀请关注有礼";
          data.content =
            "推广店铺必推玩法，引导客户邀请好友关注店铺嬴好礼，可增加店铺关注量，提升店铺权重，支持设置曝光商品，刺激转化提客户粘性";
          data.src = require("@/assets/thdImg/cover/yqgz.png");
          data.bghome = require("@/assets/thdImg/active/gzdpyl.png");
          data.path = `https://yq-hd-rc.isvjcloud.com/invitationattention?venderId=${this.$store.state.loginUserInfo.venderId}`;
          data.createStep = 2;
          data.codeUrl = coverSrc + "yqkk.png";
          data.coverSrc = coverSrc + "yqkk.png";
          data.course =
            "https://www.yuque.com/yunduanxincrm/flgan6/fdll7gygxqqiixg5";
          break;
        case 6:
          data.id = activityType;
          data.title = "完善信息有礼";
          data.createStep = 2;
          data.content =
            "可通过用户信息填写奖励设置，完善客户画像信息，增强店铺活动扩展性";
          data.src = require("@/assets/thdImg/cover/wsxx.png");
          data.bghome = require("@/assets/thdImg/active/wsxx.png");
          data.path = `https://yq-hd-rc.isvjcloud.com/perfect_information?venderId=${this.$store.state.loginUserInfo.venderId}`;
          data.codeUrl = `https://yq-hd-rc.isvjcloud.com/perfect_information?venderId=${this.$store.state.loginUserInfo.venderId}`;
          data.coverSrc = coverSrc + "ws.png";
          data.course =
            "https://www.yuque.com/yunduanxincrm/flgan6/ifs5p9ma08pezqwh";
          break;
        case 13:
          data.id = activityType;
          data.title = "开卡礼包";
          data.createStep = 2;
          data.content =
            "支持针对会员和非会员设置不同的礼包弹窗，引导非会员开卡入会";
          data.src = require("@/assets/images/integralCenter/icon_kakai.png");
          data.codeUrl = `http://yq-hd-rc.isvjcloud.com/shop.html`;
          data.coverSrc = coverSrc + "kk.png";
          data.bghome = require("@/assets/thdImg/active/kk.png");
          data.course =
            "https://www.yuque.com/yunduanxincrm/flgan6/qcuistsenhwgzk0t";

          break;
        case 14:
          data.id = activityType;
          data.title = "店铺礼包";
          data.createStep = 2;
          data.content =
            "可以选择指定目标人群，定向投放店铺礼包，礼包奖励支持东券、京豆、积分";
          data.src = require("@/assets/images/integralCenter/icon_kakai.png");
          data.codeUrl = `http://yq-hd-rc.isvjcloud.com/shop.html`;
          data.coverSrc = coverSrc + "dp.png";
          data.bghome = require("@/assets/thdImg/active/dp.png");
          data.course =
            "https://www.yuque.com/yunduanxincrm/flgan6/uy4mgghy4ny9e72k";

          break;
        case 15:
          data.id = activityType;
          data.title = "店铺礼包千人千面";
          data.bghome = require("@/assets/thdImg/active/wsxx.png");
          data.createStep = 11;
          data.content =
            "支持针对不同的人群进行礼包弹窗和礼品的定向投放，实现不同人群显示不一样的礼包弹窗，礼品支持京券、东券、京豆、积分";
          data.src = require("@/assets/images/integralCenter/icon_qrqm.png");
          data.codeUrl = `http://yq-hd-rc.isvjcloud.com/shop.html`;
          data.coverSrc = coverSrc + "dpq.png";
          data.bghome = require("@/assets/thdImg/active/dpq.png");
          data.course =
            "https://www.yuque.com/yunduanxincrm/flgan6/um9zf5weasqhc5ut";

          break;
        case 8:
          data.id = activityType;
          data.title = "幸运抽奖";
          data.createStep = 8;
          data.content =
            "缤纷有趣转盘抽奖，助力粉丝互动，多种奖品轮番吸引，中奖率自定义，成本自控，抽奖条件随心设置，提升客户参与度";
          data.src = require("@/assets/thdImg/cover/dzp.png");
          data.bghome = require("@/assets/thdImg/active/zp1.png");
          data.path = "step";
          data.codeUrl = `https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=`;
          data.coverSrc = coverSrc + "dzp.png";
          data.course =
            "https://www.yuque.com/yunduanxincrm/flgan6/nwrtk2rreapuequz";

          break;
        case 16:
          data.id = activityType;
          data.title = "下单有礼";
          data.createStep = 4;
          data.content =
            "可对会员进行下单奖励设置，通过下单权益刺激，有效提升会员下单付款转化率";
          data.src = require("@/assets/thdImg/cover/xdyl.png");
          data.bghome = require("@/assets/thdImg/active/xdyl.png");
          data.path = "polite";
          data.codeUrl = `https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=`;
          data.coverSrc = coverSrc + "xdyl.png";
          data.course =
            "https://www.yuque.com/yunduanxincrm/flgan6/qsg3bkg9bdewa3zq";

          break;
        case 17:
          data.id = activityType;
          data.title = "首单专享礼";
          data.createStep = 4;
          data.content =
            "通过首单专享礼权益，商家可对会员进行首单奖励，从而有效的提升首单转化率";
          data.src = require("@/assets/thdImg/active/sgyl.png");
          data.bghome = require("@/assets/thdImg/active/sgyl.png");
          data.path = "polite";
          data.codeUrl = `https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=`;
          data.coverSrc = coverSrc + "sgyl.jpg";
          data.course =
            "https://www.yuque.com/yunduanxincrm/flgan6/pqg64gwovulnuc3e";
          console.log("data.coverSrc------>", data.coverSrc);
          break;
        case 18:
          data.id = activityType;
          data.title = "复购有礼";
          data.createStep = 4;
          data.content =
            "通过复购有礼权益，商家可对会员进行复购奖励，从而有效的提升会员转化、复购率。";
          data.src = require("@/assets/thdImg/cover/fgyl.png");
          data.bghome = require("@/assets/thdImg/active/fgyl.png");
          data.path = "polite";
          data.codeUrl = `https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=`;
          data.coverSrc = coverSrc + "fgyl.png";
          data.course =
            "https://www.yuque.com/yunduanxincrm/flgan6/wegcwdyzxhupf3fh";

          break;
        case 19:
          data.id = activityType;
          data.title = "下单抽奖";
          data.createStep = 9;
          data.content =
            "可对会员进行下单奖励设置，根据奖项的不同可以设置不同的中奖概率，通过权益刺激有效提高用户的参与积极性从而提升会员转化。";
          data.src = require("@/assets/thdImg/cover/xdcj.png");
          data.bghome = require("@/assets/thdImg/active/xdcj.png");
          data.path = "step2";
          data.codeUrl = `https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=`;
          data.coverSrc = coverSrc + "xdcj.png";
          data.course =
            "https://www.yuque.com/yunduanxincrm/flgan6/hcrvrswygoq8xsko";

          break;
        case 20:
          data.id = activityType;
          data.title = "评价有礼";
          data.createStep = 6;
          data.content =
            "通过礼品激励买家进行评价，买家好评后可参与抽奖嬴取礼品，快速提升店铺DSR";
          data.src = require("@/assets/images/integralCenter/pjyl.jpg");
          data.bghome = require("@/assets/thdImg/active/pjyl.png");
          data.path = "evaluation";
          data.codeUrl = `https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=`;
          data.coverSrc = coverSrc + "pjyl.png";
          data.course =
            "https://www.yuque.com/yunduanxincrm/flgan6/ithh7w8xfr4zvttk";

          break;
        case 21:
          data.id = activityType;
          data.title = "裂变神券";
          data.createStep = 6;
          data.content =
            "高效裂变实用玩法，通过社交分享，邀请好友组团领券，成功裂变涨粉";
          data.src = require("@/assets/thdImg/cover/lbsq.png");
          data.bghome = require("@/assets/thdImg/active/lbsq.png");
          data.path = "evaluation";
          data.codeUrl = `https://yq-hd-rc.isvjcloud.com/clientPreview?venderId=${this.$store.state.loginUserInfo.venderId}&activityType=${activityType}`;
          data.coverSrc = coverSrc + "lvsq.png";
          data.course =
            "https://www.yuque.com/yunduanxincrm/flgan6/cpe8580f0lxv1lur";

          break;
        case 22:
          data.id = activityType;
          data.title = "天降红包雨";
          data.createStep = 6;
          data.content = "倒计时接红包，根据接红包的个数获得奖品，活跃店铺气氛";
          data.src = require("@/assets/thdImg/cover/tjhby.png");
          data.bghome = require("@/assets/thdImg/active/hby.png");
          data.path = "evaluation";
          data.codeUrl = `https://yq-hd-rc.isvjcloud.com/clientPreview?venderId=${this.$store.state.loginUserInfo.venderId}&activityType=${activityType}`;
          data.coverSrc = coverSrc + "hby.png";
          data.course =
            "https://www.yuque.com/yunduanxincrm/flgan6/glgt0n3zya856svb";

          break;
        case 23:
          data.id = activityType;
          data.title = "欢乐娃娃机";
          data.createStep = 10;
          data.content =
            "新奇趣味的在线抓娃娃游戏，玩游戏的同时赢取礼品，增加客户留存以及提升客户的粘性";
          data.src = require("@/assets/thdImg/cover/zww.png");
          data.bghome = require("@/assets/thdImg/active/zww.png");
          data.path = "games";
          data.codeUrl = `https://yq-hd-rc.isvjcloud.com/clientPreview?venderId=${this.$store.state.loginUserInfo.venderId}&activityType=${activityType}`;
          data.coverSrc = coverSrc + "zww.png";
          data.course =
            "https://www.yuque.com/yunduanxincrm/flgan6/fwnvhutzgqnewov0";

          break;
        case 24:
          data.id = activityType;
          data.title = "大家来找茬";
          data.createStep = 10;
          data.content =
            "“大家来找茬”是一款热门休闲的游戏，在限定时间内，找出两幅图的不同之处，通关后即可参与抽奖赢取礼品";
          data.src = require("@/assets/thdImg/cover/zc.png");
          data.bghome = require("@/assets/thdImg/active/zc.png");
          data.path = "games";
          data.codeUrl =
            "https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=https://jdminiapp.yucrm.cn/html/images/Preview/djzc.png";
          data.coverSrc = coverSrc + "djzc.png";
          data.course =
            "https://www.yuque.com/yunduanxincrm/flgan6/qxcwqb0og56t6lz5";

          break;
        case 27:
          data.id = activityType;
          data.title = "预售有礼";
          data.createStep = 7;
          data.content =
            "预售下单激励设置，可根据预售订单的笔数及金额设置相应奖励，刺激用户下单预售商品，提升店铺销量";
          data.src = "";
          data.bghome = require("@/assets/thdImg/active/ysyl.png");
          data.path = "games";
          data.codeUrl =
            "https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=";
          data.coverSrc = coverSrc + "ys.png";
          data.course =
            "https://www.yuque.com/yunduanxincrm/flgan6/ol8vcv42wgc8llbg";

          break;
        case 28:
          data.id = activityType;
          data.title = "预售抽奖";
          data.createStep = 7;
          data.content =
            "通过预售抽奖权益，商家可对会员进行预售奖励，根据奖项的不同可以设置不同的中奖概率，有效提高用户的参与积极性从而提升会员转化";
          data.src = "";
          data.bghome = require("@/assets/thdImg/active/yscj.png");
          data.path = "games";
          data.codeUrl = `https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=`;
          data.coverSrc = coverSrc + "ysch.png";
          data.course =
            "https://www.yuque.com/yunduanxincrm/flgan6/yfbzbf42gdfow5v6";

          break;
        case 9:
          data.id = activityType;
          data.title = "积分兑换实物";
          data.createStep = 13;
          data.content =
            "通过消耗积分兑换相应的实物奖品的表达方式，促进会员价值提升";
          data.src = require("@/assets/thdImg/cover/sw.png");
          data.bghome = require("@/assets/thdImg/active/sw.png");
          data.path = "games";
          data.codeUrl = `https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=https://jdminiapp.yucrm.cn/html/images/Preview/sw.png`;
          data.coverSrc = coverSrc + "sw.png";
          data.course =
            "https://www.yuque.com/yunduanxincrm/flgan6/lcygs841zrr34o12";

          break;
        case 10:
          data.id = activityType;
          data.title = "积分兑换优惠券";
          data.createStep = 13;
          data.content = "通过消积分获得大额优惠券，从而促进会员再次下单购买";
          data.src = require("@/assets/thdImg/cover/yhq.png");
          data.bghome = require("@/assets/thdImg/active/yhq.png");
          data.path = "games";
          data.codeUrl = `https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=https://jdminiapp.yucrm.cn/html/images/Preview/yhq.png`;
          data.coverSrc = coverSrc + "yhq.png";
          data.course =
            "https://www.yuque.com/yunduanxincrm/flgan6/uttdga390thzzvzw";

          break;
        case 29:
          data.id = activityType;
          data.title = "积分兑换京豆";
          data.createStep = 14;
          data.content =
            "用户消耗相应积分可获得京豆，支持用户自由兑换和套餐兑换";
          data.src = require("@/assets/thdImg/cover/jd.png");
          data.bghome = require("@/assets/thdImg/active/jd.png");
          data.path = "games";
          data.codeUrl = `https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=https://jdminiapp.yucrm.cn/html/images/conversion/%E7%A7%AF%E5%88%86%E5%85%91%E6%8D%A2%E4%BA%AC%E8%B1%86.png`;
          data.coverSrc = coverSrc + "dhjd.png";
          data.course =
            "https://www.yuque.com/yunduanxincrm/flgan6/mh27pdtfvsnif5hn";

          break;
        case 30:
          data.id = activityType;
          data.title = "积分兑换E卡";
          data.createStep = 14;
          data.content =
            "通过不同价值的E卡刺激用户消耗积分进行兑换，促进会员价值提升";
          data.src = require("@/assets/thdImg/cover/Ek.png");
          data.bghome = require("@/assets/thdImg/active/ek.png");
          data.path = "games";
          data.codeUrl = `https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=https://jdminiapp.yucrm.cn/html/images/conversion/%E7%A7%AF%E5%88%86%E5%85%91%E6%8D%A2E%E5%8D%A1.png`;
          data.coverSrc = coverSrc + "dhek.png";
          data.course =
            "https://www.yuque.com/yunduanxincrm/flgan6/cas9ttsibz7thdl1";
          break;
        case 31:
          data.id = activityType;
          data.title = "超级裂变券";
          data.createStep = 15;
          data.content =
            "设置不同优惠力度的优惠券，刺激用户发起拼券活动和为好友助力";
          data.src = require("@/assets/thdImg/cover/cjlb.png");
          data.bghome = require("@/assets/thdImg/active/cjlb.png");
          data.codeUrl = `https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=https://jdminiapp.yucrm.cn/html/images/Preview/cjlb.png`;
          data.coverSrc = coverSrc + "cjlb.png";
          data.course =
            "https://www.yuque.com/yunduanxincrm/flgan6/xdaezpggqb3p1cko?singleDoc# 《5.超级裂变券》";
          break;
        case 50:
          data.id = activityType;
          data.title = "情书贺卡";
          data.createStep = 50;
          data.content =
            "通过情书传递对心仪的对象表达情意，可配置商品与情书共同表达心意，接手人接收心意时可进行用户转化，可用于特定的活动场景与相关礼盒商品";
          data.src = require("@/assets/thdImg/cover/cjlb.png");
          data.bghome = require("@/assets/thdImg/active/qshk.png");
          // 模板预览二维码
          data.codeUrl = `https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=`;
          // 京东APP扫码预览
          data.coverSrc ="https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=http://cdn-image.yucrm.cn/images/Preview/qshk.png";
          data.course =
            "https://iv20ea9qhux.feishu.cn/docx/FIbOd2uoroDLwxxva40cs1xJnDe?from=from_copylink";
          break;
        case 38:
          data.id = activityType;
          data.title = "积分兑换红包";
          data.createStep = 38;
          data.content =
            "用户消耗积分兑换红包礼品，可活跃店铺用户，培养会员忠诚度";
          data.src = require("@/assets/thdImg/cover/dhhb.png");
          data.bghome = require("@/assets/thdImg/active/dhhb.png");
          data.codeUrl = `https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=https://jdminiapp.yucrm.cn/html/images/Preview/dhhb.png`;
          data.coverSrc = coverSrc + "dhhb.png";
          data.course =
            "https://www.yuque.com/yunduanxincrm/flgan6/wc5araw0zqfiaebr?singleDoc# 《6.积分兑换红包》";
          break;
        case 35:
          data.id = activityType;
          data.title = "积分锁权";
          data.createStep = 16;
          data.content =
            "通过权益刺激，促使会员完成确权且下单，有效提升会员下单付款转化率";
          data.src = require("@/assets/images/integralCenter/icon_kakai.png");
          data.codeUrl = `http://yq-hd-rc.isvjcloud.com/shop.html`;
          // data.coverSrc = coverSrc + 'kk.png'
          data.bghome = require("@/assets/thdImg/active/lockAuth.png");
          // data.course = 'https://www.yuque.com/yunduanxincrm/flgan6/qcuistsenhwgzk0t'

          break;
        case 36:
          data.id = activityType;
          data.title = "下单冲榜";
          data.createStep = 36;
          data.content =
            "可对用户进行下单奖励设置，根据名次的不同可以设置对应的奖品，引导用户下单进而领取对应奖品，有效提升用户下单付款转化率";
          data.src = require("@/assets/images/integralCenter/xdcb.png");
          data.bghome = require("@/assets/thdImg/active/xdcb.png");
          data.path = "orderRank";
          data.codeUrl = `https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=`;
          data.coverSrc = coverSrc + "xdcb.jpg";
          // data.course = 'https://www.yuque.com/yunduanxincrm/flgan6/ithh7w8xfr4zvttk'
          data.course =
            "https://www.yuque.com/yunduanxincrm/flgan6/cbwlzgdrvfld0kve?singleDoc#";

          break;
        case 37:
          let loginUserInfo = JSON.parse(
            window.sessionStorage.getItem("loginUserInfo")
          );
          data.id = activityType;
          data.title = "派样回购礼";
          data.createStep = 37;
          data.content =
            "通过权益刺激，促使会员下单派样并在指定时间内进行正装回购，完成订单收货即可锁定奖品，有效提醒会员下单付款转化率";
          data.src = require("@/assets/images/integralCenter/bly.png");
          data.bghome =
            loginUserInfo.venderId == "1000003788"
              ? require("@/assets/thdImg/active/wm.png")
              : loginUserInfo.venderId == "69268" ||
                loginUserInfo.venderId == "1000080364"
              ? require("@/assets/thdImg/active/zj.png")
              : require("@/assets/thdImg/active/bly.png");
          data.path = "sendReBuy";
          data.codeUrl = `https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=`;
          data.coverSrc =
            (loginUserInfo.venderId == "1000003788" ||
            loginUserInfo.venderId == "69268" ||
            loginUserInfo.venderId == "1000080364"
              ? "https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=http://cdn-image.yucrm.cn/images/Preview/"
              : coverSrc) +
            (loginUserInfo.venderId == "1000003788"
              ? "wm"
              : loginUserInfo.venderId == "69268" ||
                loginUserInfo.venderId == "1000080364"
              ? "zj"
              : "pyhg") +
            ".jpg";
          // data.course = 'https://www.yuque.com/yunduanxincrm/flgan6/ithh7w8xfr4zvttk'
          // data.course = 'https://www.yuque.com/yunduanxincrm/flgan6/cbwlzgdrvfld0kve?singleDoc#'

          break;
        case 42:
          data.id = activityType;
          data.title = "派样回购礼(随单发)";
          data.createStep = 42;
          data.content = "将样品派送与回购激励相结合，从而有效提高复购率";
          data.path = "promoSendReBuy";
          break;
        case 39:
          data.id = activityType;
          data.title = "生日有礼";
          data.createStep = 39;
          data.content =
            "生日有礼是提高会员忠诚度和满意度的重要政策，让会员在生日的时候收取会员奖励，提高会员好感度";
          data.src = require("@/assets/thdImg/active/brithDay.png");
          data.bghome = require("@/assets/thdImg/active/brithDay.png");
          data.path = "sendReBuy";
          data.codeUrl = `https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=`;
          data.coverSrc = coverSrc + "sryl.png";
          data.course =
            "https://www.yuque.com/yunduanxincrm/flgan6/iddkcdvp38vdhh5u?singleDoc# 《7.生日有礼》";
          break;
        case 44:
          data.id = activityType;
          data.title = "会员升级礼";
          data.createStep = 44;
          data.content =
            "通过提供升级奖励，激励会员提升等级，增强忠诚度并享受更多专属特权和优惠。";
          data.src = require("@/assets/thdImg/active/member.png");
          data.bghome = require("@/assets/thdImg/active/member.png");
          data.path = "sendReBuy";
          data.codeUrl = `https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=`;
          data.coverSrc = "https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=http://cdn-image.yucrm.cn/images/Preview/hysjl.png"
          data.course =
            "https://www.yuque.com/yunduanxincrm/flgan6/sc0hknnp5wigggau?singleDoc# 《8.会员升级礼》";
          break;
        case 41:
          data.id = activityType;
          data.title = "晒单有礼";
          data.createStep = 41;
          data.content =
            "通过礼品激励用户进行评价，买家好评，提交评价截图即有机会获得指定礼品，帮助提升店铺整体评价";
          data.src = require("@/assets/thdImg/active/sdyl.png");
          data.bghome = require("@/assets/thdImg/active/sdyl.png");
          data.path = "postOrders";
          data.codeUrl = `https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=`;
          // data.coverSrc = coverSrc + 'sdyl.png'
          data.coverSrc =
            "https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=http://cdn-image.yucrm.cn/images/Preview/sdyl.png";
          // data.course = 'https://www.yuque.com/yunduanxincrm/flgan6/iddkcdvp38vdhh5u?singleDoc# 《7.晒单有礼》'
          break;
        case 58:
          data.id = activityType;
          data.title = "积分兑换爱奇艺会员";
          data.createStep = 58;
          data.content =
            "用户消耗积分兑换可获得爱奇艺会员，通过热门视频平台会员，促进会员价值提升";
          data.src = "https://cdn-image.yucrm.cn/images/Preview/aqy-big.png";
          data.bghome = "https://cdn-image.yucrm.cn/images/Preview/aqy-big.png";
          data.codeUrl = "https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=https://cdn-image.yucrm.cn/images/Preview/aqy-big.png"
          data.coverSrc =  "https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=https://cdn-image.yucrm.cn/images/Preview/aqy-big.png"
          data.course = "https://www.yuque.com/yunduanxincrm/flgan6/kvqpvswxw3ob1b9c"
          break;
        case 59:
          data.id = activityType;
          data.title = "积分兑换PLUS会员";
          data.createStep = 59;
          data.content =
            "用户消耗积分兑换可获得PLUS会员，提升会员的消费权益，促进会员价值提升";
          data.src = "https://cdn-image.yucrm.cn/images/Preview/plus-big.png";
          data.bghome = "https://cdn-image.yucrm.cn/images/Preview/plus-big.png";
          data.codeUrl =  "https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=https://cdn-image.yucrm.cn/images/Preview/plus-big.png"
          data.coverSrc = "https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=https://cdn-image.yucrm.cn/images/Preview/plus-big.png"
          data.course = "https://www.yuque.com/yunduanxincrm/flgan6/kvqpvswxw3ob1b9c"
          break;
        case 60:
          data.id = activityType;
          data.title = "积分兑换礼品卡";
          data.createStep = 60;
          data.content =
            "用户消耗积分兑换可获得礼品卡，通过礼品卡可兑换其他虚拟奖品，多元化的吸引用户";
          data.src = "https://cdn-image.yucrm.cn/images/Preview/giftcard-big.png";
          data.bghome = "https://cdn-image.yucrm.cn/images/Preview/giftcard-big.png";
          data.codeUrl = "https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=https://cdn-image.yucrm.cn/images/Preview/giftcard-big.png"
          data.coverSrc = "https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=https://cdn-image.yucrm.cn/images/Preview/giftcard-big.png"
          data.course = "https://www.yuque.com/yunduanxincrm/flgan6/kvqpvswxw3ob1b9c"
          break;
        case 61:
            data.id = activityType;
            data.title = "积分兑换百度网盘";
            data.createStep = 61;
            data.content =
              "用户消耗积分兑换可获得百度网盘，网盘可配置有价值的资料给予会员，促进会员价值提升";
            data.src = "https://cdn-image.yucrm.cn/images/Preview/bdwp-big.png";
            data.bghome = "https://cdn-image.yucrm.cn/images/Preview/bdwp-big.png";
            data.codeUrl = "https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=https://cdn-image.yucrm.cn/images/Preview/bdwp-big.png"
            data.coverSrc = "https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=https://cdn-image.yucrm.cn/images/Preview/bdwp-big.png"
            data.course = "https://www.yuque.com/yunduanxincrm/flgan6/kvqpvswxw3ob1b9c"
            break;
      }
      return data;
    },
    handleTem(item, index) {
      this.tempIndex = index;
      this.tempItem = item;
      this.pageData.current = 1;
      if (this.fitersChooseIF([13, 14, 15])) this.getPolite();
      if (
        this.fitersChooseIF([27, 28, 19, 1, 16, 17, 18, 8, 34, 20, 36, 39, 41, 44, 50])
      )
        this.getPolitely();
    },
    // 分页查询事件
    handleSizeChange(val) {
      this.pageData.size = val;
      if (this.fitersChooseIF([27, 28])) this.getPolitely();
      if (this.fitersChooseIF([13, 14, 15])) this.getPolite();
    },
    handleCurrentChange(val) {
      this.pageData.current = val;
      if (this.fitersChooseIF([27, 28])) this.getPolitely();
      if (this.fitersChooseIF([13, 14, 15])) this.getPolite();
    },

    // 店铺礼包千人千面数据初始化 // 获取模板
    async getPolite() {
      this.loading = true;
      let params = {
        id: this.form.id,
        title: this.form.name,
        current: this.pageData.current,
        size: this.pageData.size,
        dirId: this.tempItem.id,
        giftType:
          this.activityData.id == 13 ? 0 : this.activityData.id == 14 ? 1 : 2,
      };
      // 开卡礼包版本
      const { data } = await getGiftBagTemplate(params);
      this.loading = false;
      this.giftList = data.records.map((item) => ({
        ...item,
        imgUrl:
          this.activityData.id == 13
            ? item.templateUrl
            : item.templateExampleUrl,
        name: item.templateName,
        days:
          item.expirationType == 1
            ? this.getDaysBetween(
                item.expirationStartDate,
                item.expirationEndDate
              )
            : "",
        tempCode:
          this.activityData.id == 13
            ? `${this.activityData.codeUrl}?image=${item.templateUrl}`
            : `${this.activityData.codeUrl}?image=${item.templateExampleUrl}`,
      }));
      console.log(this.giftList, 333);
      this.pageData.total = data.total * 1;
      this.$nextTick(() => {
        this.getCodeIMG1();
      });
    },
    async getPolitely() {
      let params = {
        id: this.form.id,
        imageName: this.form.name,
        current: this.pageData.current,
        size: this.pageData.size,
        templateGroupId: this.tempItem.id,
        source: 4,
        hdTaskType: this.activityData.id,
      };
      const { data } = await sellerImage(params);
      this.giftList = data.records.map((item) => {
        return {
          ...item,
          imgUrl:
            this.activityData.id == 8 || this.activityData.id == 19
              ? item.secondImageUrl
              : item.imageUrl,
          name: item.imageName,
          days: item.activityStartTime
            ? this.getDaysBetween(item.activityStartTime, item.activityEndTime)
            : "",
          tempCode:
            this.activityData.codeUrl +
            (this.activityData.id == 34 || this.activityData.id == 39 || this.activityData.id == 44 || this.activityData.id == 50
              ? item.imageUrl
              : item.secondImageUrl),
        };
      });
      this.pageData.total = data.total * 1;
      this.$nextTick(() => {
        this.getCodeIMG1();
      });
    },
    // 使用此模板
    async handleSet(item, index) {
      let refName = "createStep" + this.activityData.createStep;
      if (this.fitersChooseIF([1, 2, 3, 4, 5, 6, 7, 34])) {
        this.activityDataInfo = item;
        this.createStep = this.activityData.createStep;
        this.$nextTick(() => {
          if (this.fitersChooseIF([1, 34])) {
            this.$refs[refName].nextStep(index + 1, item.id);
          } else {
            this.$refs[refName].nextStep(index + 1);
          }
        });
      } else if (this.fitersChooseIF([8])) {
        this.createStep = this.activityData.createStep;
        this.$nextTick(() => {
          this.$refs[refName].nextStepKai(index + 1, item.id, item);
        });
      } else if (this.fitersChooseIF([19])) {
        const { message: res } = await publicOpen();
        if (res) {
          this.createStep = this.activityData.createStep;
          this.$nextTick(() => {
            this.$refs[refName].toCreated1(index + 1, item.id);
          });
        } else {
          if (this.venderType) {
            return this.$message.warning(
              "自营店铺需要搭配云短信CRM使用！请联系客服！"
            );
          } else {
            this.createStep = this.activityData.createStep;
            this.$nextTick(() => {
              this.$refs[refName].toCreated1(index + 1, item.id);
            });
          }
        }
      } else if (this.fitersChooseIF([14, 15])) {
        getValidActivity().then((res) => {
          if (res.data) {
            const message =
              "当前正在进行【" +
              res.data[0].activityName +
              "】活动" +
              res.data[0].activityStartTime +
              "~" +
              res.data[0].activityEndTime +
              "，必须结束后才能新建！";
            this.$message.warning(message);
            return;
          }
          this.createStep = this.activityData.createStep;
          this.$nextTick(() => {
            this.$refs[refName].nextStepKai1(item);
          });
        });
      } else if (this.fitersChooseIF([16, 17, 18, 27, 28, 39, 41, 44, 50])) {
        const { message: res } = await publicOpen();
        if (res) {
          this.createStep = this.activityData.createStep;
          this.$nextTick(() => {
            this.$refs[refName].nextStepKai(item, item.id);
          });
        } else {
          if (this.venderType) {
            return this.$message.warning(
              "自营店铺需要搭配云短信CRM使用！请联系客服！"
            );
          } else {
            this.createStep = this.activityData.createStep;
            this.$nextTick(() => {
              this.$refs[refName].nextStepKai(item, item.id,index+1);
            });
          }
        }
      } else if (this.fitersChooseIF([36])) {
        let {
          code: code,
          message: message,
          data: data,
        } = await checkOpenCrmByVenderType();
        console.log(code, message, data);
        if (code == 1) {
          this.orderCRMtime = data;
          this.createStep = this.activityData.createStep;
          this.$nextTick(() => {
            this.$refs[refName].nextStepKai(item, item.id);
          });
        } else {
          if (message) {
            this.$message.warning(message);
            return;
          } else {
            this.$message.warning(data.message);
          }
        }
      } else {
        this.createStep = this.activityData.createStep;
        this.$nextTick(() => {
          this.$refs[refName].nextStepKai(item);
        });
      }
    },
    // 品牌定制弹窗
    handleOpen() {
      const href =
        "tencent://message/?uin=800152084&Site=%E5%9C%A8%E7%BA%BF%E5%AE%A2%E6%9C%8D&Menu=yes";
      window.open(href, "_self");
    },
    // 生成二维码
    getCodeIMG() {
      // const url = this.activityData.codeUrl;
      if (this.$refs.QRcode_img) {
        this.$refs.QRcode_img.innerHTML = "";
        new QRCode("QRcode_img", {
          errorCorrectionLevel: "H", //容错级别 L M Q H
          width: 134, // 设置宽度，单位像素
          height: 134, // 设置高度，单位像素
          // text: url, // 设置二维码内容或跳转地址
          text: this.activityData.coverSrc,
        });
      }
    },
    // 生成二维码
    getCodeIMG1() {
      const codeImg = document.querySelectorAll(".qrCodeIMG");
      for (let index = 0; index < codeImg.length; index++) {
        const elementbox = codeImg[index];
        elementbox.innerHTML = "";
      }
      for (let index = 0; index < codeImg.length; index++) {
        const element = codeImg[index];
        new QRCode(element, {
          width: 140, // 设置宽度，单位像素
          height: 140, // 设置高度，单位像素
          // text: url, // 设置二维码内容或跳转地址
          text: this.giftList[index].tempCode,
        });
      }
    },
    // 限免日期
    getDaysBetween(dateString1, dateString2) {
      const startDate = Date.parse(dateString1);
      const nowDate = Date.parse(new Date());
      const endDate = Date.parse(dateString2);
      if (startDate > endDate) {
        return 0;
      }
      if (startDate == endDate) {
        return 1;
      }
      let days = 0;
      if (nowDate > startDate) {
        days = (endDate - nowDate) / (1 * 24 * 60 * 60 * 1000);
      } else {
        days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
      }
      return Math.floor(days) == 0 ? "1天" : Math.ceil(days) + "天";
    },
    // this.rowData.activityType活动类型判断显示隐藏type === "=="则arr里面显示,type === "！="   则arr里面不显示
    fitersChooseIF(arr, type = "==") {
      let activityType = this.$route.meta.activityType;
      if (type === "==") {
        let isfaly = false;
        arr.forEach((item) => {
          if (activityType == item) {
            isfaly = true;
          }
        });
        return isfaly;
      } else {
        let isfaly = true;
        arr.forEach((item) => {
          if (activityType == item) {
            isfaly = false;
          }
        });
        return isfaly;
      }
    },
    handleCreate() {
      window.open(
        "https://fw.jd.com/main/detail/FW_GOODS-1631?p=fw&t=pcsearch",
        "_self"
      );
    },
  },
};
